import { render } from "./App.vue?vue&type=template&id=27a74d1c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=27a74d1c&lang=scss"

import exportComponent from "/home/runner/work/toki-pona-site/toki-pona-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__